export default "__VITE_ASSET__040879e6__"